import React from 'react';
import { Box, IconButton, Typography, Modal, Button } from '@mui/material';
import { Close } from '@mui/icons-material';

interface DeleteSessionModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteSessionModal: React.FC<DeleteSessionModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: 24,
          p: 0,
          minWidth: 700,
          maxWidth: 700,
          outline: 'none',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            backgroundColor: '#1A55F9',
            borderRadius: '8px 8px 0 0',
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: '16px', color: '#fff' }}>
            Delete Session
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: '#fff',
              '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ p: 2 }}>
          <Typography sx={{ fontSize: '16px', color: '#333' }}>
            Do you want to delete this session?
          </Typography>
        </Box>

        {/* Actions */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1,
            p: 2,
            borderTop: '1px solid #E5E5E5',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              color: '#666',
              textTransform: 'none',
              fontSize: '14px',
              '&:hover': { backgroundColor: '#f5f5f5' },
            }}
          >
            No
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            sx={{
              backgroundColor: '#1A55F9',
              textTransform: 'none',
              fontSize: '14px',
              '&:hover': { backgroundColor: '#1547D9' },
            }}
          >
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteSessionModal;
